import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormCheckbox({
  id,
  name,
  description,
  value,
  required,
  errorMessage,
  disabled,
}) {
  return (
    <div style={{ paddingBottom: "1.7em" }}>
      <Form.Checkbox
        name={id}
        text={name}
        defaultValue={value}
        toggle={false}
        data-test="form-checkbox"
        required={required}
        errorMessage={errorMessage}
        disabled={disabled}
        description={description}
        showDescriptionBelow
      />
    </div>
  );
}

FormCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.bool,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

FormCheckbox.defaultProps = {
  value: false,
  required: false,
  errorMessage: "Please select the checkbox",
  disabled: false,
  description: "",
};

export default FormCheckbox;
